const isNull = (x) => x === null;
export default isNull;
